import React from 'react';
import Chart from 'react-apexcharts';

const BarChart = ({ title, series, categories, }) => {
  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '50%',
      },
    },
    colors: ['#3b82f6'],
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories || [],
      labels: {
        style: {
          fontSize: '12px',
          fontFamily: "'Inter', sans-serif",
          fontWeight: 500,
          colors: '#64748b',
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
          fontFamily: "'Inter', sans-serif",
          colors: '#64748b',
        },
      },
      title: {
        text: 'Likes',
        style: {
          fontSize: '14px',
          fontFamily: "'Inter', sans-serif",
          fontWeight: 600,
          color: '#1e293b',
        },
      },
    },
    grid: {
      borderColor: 'rgba(203, 213, 225, 0.3)',
      strokeDashArray: 5,
    },
    tooltip: {
      theme: 'dark',
      style: {
        fontSize: '12px',
        fontFamily: "'Inter', sans-serif",
      },
    },
    title: {
      text: title,
      align: 'center',
      style: {
        fontSize: '18px',
        fontFamily: "'Inter', sans-serif",
        fontWeight: 600,
        color: '#1e293b',
      },
    },
    legend: {
      show: true,
      position: 'top',
      fontSize: '14px',
      fontFamily: "'Inter', sans-serif",
      fontWeight: 500,
      labels: { colors: '#1e293b' },
    },
  };

  const chartSeries = [
    {
      name: series[0]?.name || 'Page Likes',
      data: series[0]?.data || [],
    },
  ];

  return (
    
    <div style={{ height: '350px', position: 'relative', padding: '16px' }}>
      <Chart options={chartOptions} series={chartSeries} type="bar" height="100%" width="100%"/>
    </div>
  );
};

export default BarChart;